"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.hex2rgb=function(e){var r=parseInt(e.slice(1),16);return{r:r>>16&255,g:r>>8&255,b:255&r}};
